import { createSlice } from '@reduxjs/toolkit';
import { ISeoData } from '../../types/seoData';

const initialState: ISeoData = {
  description: '',
  h1: '',
  title: '',
};

export const seoDataSlice = createSlice({
  name: 'seoData',
  initialState,
  reducers: {},
});

export const { reducer: seoDataReducer } = seoDataSlice;
